var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"mt-5 mb-5",attrs:{"md":"6","offset-md":"3"}},[_c('b-card',{staticClass:"mt-5",attrs:{"header":"Acheter un bon cadeau"}},[_c('voucher-pitch',{on:{"done":_vm.onSuccess}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }